import { useRef, useState } from 'react';
import { RECOVERY_NOTICE, requestAuthRecovery } from '../../lib/authRecovery';
import AuthPill from './AuthPill';
import { VERSION } from '../../config/version';
import { poweredByLine, webVersionLabel } from '../../lib/signInBranding';

export default function FinishTeamInvitation({ client, user, onSignOut }) {
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');
    const submitting = useRef(false);

    async function resend() {
        if (submitting.current) return;
        submitting.current = true; setBusy(true); setError('');
        try {
            await requestAuthRecovery(client, 'invite', user.email);
            setSent(true);
        } catch (failure) {
            setError(failure.message);
        } finally {
            submitting.current = false; setBusy(false);
        }
    }

    return <div className="tenant-sign-in flex min-h-screen items-center justify-center p-6">
        <div className="w-full max-w-md space-y-4 rounded-xl border border-[var(--surface-border)] bg-[var(--surface-raised)] p-6 text-[var(--ink)]">
            <h1 className="text-xl font-semibold">Finish your team invitation</h1>
            <p>Your team invitation has expired. Resend it to finish joining Central Command.</p>
            {sent && <p role="status">{RECOVERY_NOTICE}</p>}
            {error && <p role="alert">{error}</p>}
            <AuthPill disabled={busy || sent} onClick={resend} success={sent} successLabel="Instructions sent">
                {busy ? 'Sending...' : 'Resend'}
            </AuthPill>
            <AuthPill disabled={busy} onClick={onSignOut}>Sign Out</AuthPill>
        </div>
        <footer className="tenant-sign-in-footer">{poweredByLine(webVersionLabel(VERSION))}</footer>
    </div>;
}
